var map = {
	"./address_image.svg": 128,
	"./animated_ashutosh.png": 129,
	"./animated_logo.svg": 130,
	"./avatar_cropped_resized_transparent.png": 131,
	"./blogs_image.svg": 132,
	"./cloud_infrastructure.svg": 133,
	"./codeInLogo.png": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./data_science.svg": 137,
	"./deeplearning_ai_logo.png": 138,
	"./delhivery_logo.png": 139,
	"./developerActivity.svg": 140,
	"./download.png": 141,
	"./dsc_logo.png": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./feelingProud.svg": 145,
	"./freecopy_logo.png": 146,
	"./fullstack.svg": 147,
	"./gcp_logo.png": 148,
	"./github_logo.png": 149,
	"./googleAssistant.jpg": 150,
	"./googleAssistant.svg": 151,
	"./google_logo.png": 152,
	"./ibm_logo.png": 153,
	"./iiitk_logo.png": 154,
	"./intel_logo.jpg": 155,
	"./iu_logo.png": 156,
	"./jsFramework.svg": 157,
	"./kahe-logo-1.png": 158,
	"./legato_logo.png": 159,
	"./manOnTable.svg": 160,
	"./me1.jpeg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./my.jpeg": 165,
	"./nextuLogo.jpg": 166,
	"./nptel_logo.png": 167,
	"./physics.png": 168,
	"./portfolio.gif": 169,
	"./programmer.svg": 170,
	"./projects_image.svg": 171,
	"./pwa.png": 172,
	"./react.png": 173,
	"./saayaHealthLogo.png": 174,
	"./stanford_logo.png": 175,
	"./talksCardBack.svg": 176,
	"./talksCardBackAlt.svg": 177,
	"./tiktok_logo.png": 178,
	"./ui_ux_design.svg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;